import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const BASE_URL = `${API_BASE_URL}/clients/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

const clientService = {
  listClients: (filterField = null, filterValue = null, searchValue = null, sortBy = '-created_at', page = 1, includeInactive = false) => {
    const params = {
      ordering: sortBy,
      page: page
    };

    if (searchValue) {
      params.search = searchValue;
    }

    if (filterField && filterValue) {
      params[filterField] = filterValue;
    }

    if (includeInactive) {
      params.include_inactive = 'true';
    }

    return axios.get(BASE_URL, {
      headers: getHeaders(),
      params
    });
  },

  getClientById: (id) => {
    // include_inactive=true: callers fetch by a known ID (e.g. a Client Quote's
    // client FK), so the client must be returned even if it was deactivated later.
    return axios.get(`${BASE_URL}${id}/`, {
      headers: getHeaders(),
      params: { include_inactive: 'true' }
    });
  },

  createClient: (data) => {
    return axios.post(BASE_URL, data, {
      headers: getHeaders()
    });
  },

  updateClient: (id, data) => {
    return axios.patch(`${BASE_URL}${id}/`, data, {
      headers: getHeaders()
    });
  },

  deleteClient: (id) => {
    return axios.delete(`${BASE_URL}${id}/`, {
      headers: getHeaders()
    });
  },

  toggleActive: (id) => {
    return axios.patch(`${BASE_URL}${id}/toggle_active/`, {}, {
      headers: getHeaders()
    });
  },

  listInactiveClients: (filterField = null, filterValue = null, searchValue = null, sortBy = '-created_at', page = 1) => {
    const params = {
      ordering: sortBy,
      page: page
    };

    if (searchValue) {
      params.search = searchValue;
    }

    if (filterField && filterValue) {
      params[filterField] = filterValue;
    }

    return axios.get(`${BASE_URL}inactive/`, {
      headers: getHeaders(),
      params
    });
  }
};

export default clientService;
